/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Rank_BasicInputs */



/**
* | output |
* | --- |
* | "Basic" |
*
* @param {Tfield_Rank_BasicInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_rank_basic = /** @type {((inputs?: Tfield_Rank_BasicInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Rank_BasicInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basique")
	if (locale === "es") return /** @type {LocalizedString} */ ("Básico")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Básico")
	if (locale === "it") return /** @type {LocalizedString} */ ("Base")
	return /** @type {LocalizedString} */ ("Basic")
});